import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]
  static values = {
    headerId: { type: String, default: "match-scoreboard" }
  }

  connect() {
    this.header = document.getElementById(this.headerIdValue)
    this.parent = this.element.parentElement
    const restoredState = this.parent?.dataset.compactBarState

    if (restoredState === "visible") {
      this.#showBar()
    } else if (restoredState === "hidden") {
      this.#hideBar()
    } else if (this.header) {
      const threshold = Math.floor(this.header.offsetHeight / 2)
      const rect = this.header.getBoundingClientRect()
      if (rect.bottom > threshold) {
        this.#hideBar()
      } else {
        this.#showBar()
      }
    }

    if (!this.header) return

    const threshold = Math.floor(this.header.offsetHeight / 2)

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0]
      if (entry.isIntersecting) {
        this.#hideBar()
      } else {
        this.#showBar()
      }
      if (this.parent) {
        this.parent.dataset.compactBarState = entry.isIntersecting ? "hidden" : "visible"
      }
    }, { rootMargin: `-${threshold}px 0px 0px 0px` })

    this.observer.observe(this.header)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.barTarget.classList.remove("fixed", "z-50")
    this.barTarget.style.top = ""
    this.barTarget.style.left = ""
    this.barTarget.style.right = ""
    this.barTarget.style.marginTop = ""
  }

  #showBar() {
    this.barTarget.classList.remove("hidden")
    this.barTarget.classList.add("fixed", "z-50")
    this.barTarget.style.top = "2px"
    this.barTarget.style.left = "2px"
    this.barTarget.style.right = "2px"
    this.barTarget.style.marginTop = "0"
    if (this.parent) {
      this.parent.style.paddingTop = "0"
    }
  }

  #hideBar() {
    this.barTarget.classList.add("hidden")
    this.barTarget.classList.remove("fixed", "z-50")
    this.barTarget.style.top = ""
    this.barTarget.style.left = ""
    this.barTarget.style.right = ""
    this.barTarget.style.marginTop = ""
    if (this.parent) {
      this.parent.style.paddingTop = ""
    }
  }
}
